import * as React from 'react';
import '../css/SuperUserPageView.css';
import { connect, ConnectedProps } from 'react-redux';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import {IProduct, IDisclaimer} from "../../../infrastructure/interfaces";
import DeleteConfirmModal from "../../Modals/DeleteConfirmModal";
import DisclaimerEditorModal from "../../Modals/DisclaimerEditorModal";
import {deleteDisclaimer, saveDisclaimer} from "../../../actions/actions";

export interface IDisclaimerTableState {
    previewingProduct: IProduct | null;
    productsFilter: string;
    typesFilter: string;
    categoryFilter: string;
    publishedFilter: string;
    showDisclaimerEditorModal: boolean;
    showDeleteDisclaimerModal: boolean;
    disclaimerToDelete: IDisclaimer | undefined;
    disclaimerToEdit: IDisclaimer | undefined;
}

interface DisclaimersTableStateProps {
    disclaimers: IDisclaimer[];
}
const mapStateToProps = (state: any): DisclaimersTableStateProps => {
    return {
        disclaimers: state.wizard.disclaimers,
    };
};

interface DisclaimersTableDispatchProps {
    deleteDisclaimer(disclaimer: IDisclaimer): void;
    saveDisclaimer(disclaimer: IDisclaimer): void;
}
const mapDispatchToProps = (dispatch: any): DisclaimersTableDispatchProps => {
  return {
    deleteDisclaimer: (disclaimer: IDisclaimer) => {
      dispatch(deleteDisclaimer(disclaimer));
    },
    saveDisclaimer: (disclaimer: IDisclaimer) => {
      dispatch(saveDisclaimer(disclaimer));
    },
  };
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type IDisclaimerTableProps = PropsFromRedux & {
};

class DisclaimersTable extends React.Component<IDisclaimerTableProps, IDisclaimerTableState> {
  tableRow: HTMLElement;

  constructor(props: IDisclaimerTableProps) {
    super(props);

    this.state = {
      previewingProduct: null,
      productsFilter: '',
      typesFilter: '',
      categoryFilter: '',
      publishedFilter: '',
      showDisclaimerEditorModal: false,
      showDeleteDisclaimerModal: false,
      disclaimerToDelete: undefined,
      disclaimerToEdit: undefined,
    };
  }

  onEditDisclaimer(disclaimer: IDisclaimer) {
      this.setState({
          showDisclaimerEditorModal: true,
          disclaimerToDelete: undefined,
          disclaimerToEdit: disclaimer,
      });
  }

  onCreateDisclaimer() {
      this.setState({
          showDisclaimerEditorModal: true,
          disclaimerToDelete: undefined,
          disclaimerToEdit: undefined,
      });
  }

  onDeleteDisclaimer(disclaimer: IDisclaimer) {
      this.setState({
          showDeleteDisclaimerModal: true,
          disclaimerToDelete: disclaimer,
          disclaimerToEdit: undefined,
      });
  }

  closeModals = () => {
      this.setState({
        showDisclaimerEditorModal: false,
        showDeleteDisclaimerModal: false,
        disclaimerToDelete: undefined,
        disclaimerToEdit: undefined,
      });
  };

  render() {
    const disclaimersSafe: IDisclaimer[]  = this.props.disclaimers ? this.props.disclaimers : [];

    return (
      <div className="inner-su-container">
        <div className="manage-items-row-offsetRight">
          <div className="in-row-text-container-products">
            Manage Disclaimers
          </div>

          <div className="in-row-button-container">
            <button
                className="btn primary-green large"
                onClick={() => this.onCreateDisclaimer()}
                title={TooltipCont.CREATE_DISCLAIMER}
              >
                Create New Disclaimer
            </button>
          </div>
        </div>

        <DeleteConfirmModal
            show={this.state.showDeleteDisclaimerModal}
            onClose={ this.closeModals }
            onSave={() => {
                if (!!this.state.disclaimerToDelete) {
                  this.props.deleteDisclaimer(this.state.disclaimerToDelete);
                }
                this.closeModals();
            }}
            title="Delete disclaimer?"
        />

        <DisclaimerEditorModal
            show={this.state.showDisclaimerEditorModal}
            onClose={ this.closeModals }
            disclaimer={this.state.disclaimerToEdit}
            onSave={(disclaimer: IDisclaimer) => {
                this.props.saveDisclaimer(disclaimer);
                this.closeModals();
            }}
        />
  
        <table className="table-scrollableSU documents-table">
          <thead style={{ paddingRight: getScrollbarWidth() }}>
            <tr>
              <th className="disclaimerDescription">Details</th>
              <th className="disclaimerType">Type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="document-table-body">
            {disclaimersSafe.map((d, index, array) =>
              <tr key={d.id} ref={tr => this.tableRow = tr!}>
                <td className="disclaimerDescription"
                        dangerouslySetInnerHTML={{__html:d.description}}
                    />
                <td className="disclaimerType">
                        {d.document_type == "Brochure" ? "Quad Fold" : d.document_type}
                </td>
                <td>
                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => this.onEditDisclaimer(d)}
                      title={TooltipCont.EDIT}
                      disabled={false}
                    >
                      Edit
                    </button>

                    <button
                        className="btn primary-red"
                        onClick={() => this.onDeleteDisclaimer(d)}
                        title={TooltipCont.DELETE}
                        disabled={false}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>);
  }
}
export default connector(DisclaimersTable);



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/DisclaimersTable.tsx